var formatTree = function(root) {
	var result = root.filter(v=>v.pid==0);
	if(result.length>0) {
		result = getChild(result,root)
	}
	return result;
}
var getChild = function(arr,root) {
	var result = arr.map(v=>{
		var second = root.filter(v1=>v1.pid == v.id);
		if(second.length > 0) {
			v.children = second;
			getChild(second,root)
		}
		return v;
	});

	return result;
}
// huoqu1id
var gettreeid = function(e){
		let str=[];
		str.push(String(e[0].id))
		// str.push(String(e[0].id))
		if(e[0].children!=undefined){
			str.push(gettreeid(e[0].children))
		}
		return str.flat()
	}
var gettreeidlast = function(e){
		let str='';
		str=e[0].id;
		if(e[0].children!=undefined){
			str=(gettreeidlast(e[0].children))
		}
		return str
	}
	
var mutation = {
	//state
	setSetdata(state,{data,key}){
		state[key] = data;
	},
	setTrees(state,{ trees }) {
		if(trees) {
			let tree = formatTree(trees);
	
	  let list=[];
	
	   for(let i=0; i<tree.length; i++){
	        tree[i].value = tree[i].id;
	        tree[i].label = tree[i].title;
	        tree[i].lid = tree[i].id+tree[i].title;
	        if(tree[i].children !=undefined){
				tree[i].leaf=false;
				tree[i].leved=2;
	            for(let j=0; j< tree[i].children.length; j++){
	              tree[i].children[j].value = tree[i].children[j].id;
	              tree[i].children[j].label = tree[i].children[j].title;
	              tree[i].children[j].lid = tree[i].children[j].id+tree[i].children[j].title;
				  tree[i].children[j].leaf=true;
				   tree[i].children[j].leved=3;
				  
	            }
	            }
	        }
	      state.trees = tree;
			// if(window.localStorage.getItem('Ttreeinfoxb')){
			// 	let Ttreeinfoxb = window.localStorage.getItem('Ttreeinfoxb');
			// 	Ttreeinfoxb = JSON.parse(Ttreeinfoxb);
			// 	state.tree_info = [];//将tree_info 置空
			// 	state.tree_info = Ttreeinfoxb;
			// }else{
				state.tree_info = [];//将tree_info 置空
				state.tree_info = [tree[0],tree[0].children[0]];  //将目录树的第一条内容,及第一条内容子内容的第一条存入tree_info
				state.tree_infos = [tree[0].id,tree[0].children[0].id]; //将目录树的第一条内容,及第一条内容子内容的第一条存入tree_info               
				state.jie ='';
				state.jie = tree[0].children[0].id;
			// }
		}
	
	},
	setTreessk(state,{ trees }) {
		if(trees) {
			let tree = formatTree(trees);
	  let list=[];
	   for(let i=0; i<tree.length; i++){
	        tree[i].value = tree[i].id;
	        tree[i].label = tree[i].title;
	        if(tree[i].children !=undefined){
	            for(let j=0; j< tree[i].children.length; j++){
	              tree[i].children[j].value = tree[i].children[j].id;
	              tree[i].children[j].label = tree[i].children[j].title;
				  if(tree[i].children[j].children!=undefined){
					  let chils = tree[i].children[j].children;
					  for(let k=0; k<chils.length; k++){
						chils[k].value =chils[k].id;
						chils[k].label =chils[k].title;
					  }
				  }
	            }
	            }
	        }
	      state.sktrees = tree;
		   let canup = false;
		   for(let i=0; i<tree.length; i++){
			   if(tree[i].id == state.sktree_infos[0]){
				   canup = true;
			   }
		   }
		   // console.log(state.sktree_info)
			// if(window.localStorage.getItem('Ttreeinfoxb')){
			// 	let Ttreeinfoxb = window.localStorage.getItem('Ttreeinfoxb');
			// 	Ttreeinfoxb = JSON.parse(Ttreeinfoxb);
			// 	state.tree_info = [];//将tree_info 置空
			// 	state.tree_info = Ttreeinfoxb;
			// }else{
				state.sktree_info = [];//将tree_info 置空
				state.sktree_info = [tree[0],tree[0].children[0]];  //将目录树的第一条内容,及第一条内容子内容的第一条存入tree_info
				if(canup){
					
				}else{
					state.sktree_infos =gettreeid(tree);
					state.skjie = gettreeidlast(tree);
				}
				// state.sktree_infos.length==0?state.sktree_infos =gettreeid(tree):''; //将目录树的第一条内容,及第一条内容子内容的第一条存入t
	// 			 state.sktree_infos.length==0?state.skjie = gettreeidlast(tree):'';
	
			// }
		}
	
	},
	
}
export default mutation



// WEBPACK FOOTER //
// ./src/store/modules/xiaoben/mutation.js